import { render, staticRenderFns } from "./RedirectItems.vue?vue&type=template&id=3bdf9f0c"
import script from "./RedirectItems.vue?vue&type=script&lang=js"
export * from "./RedirectItems.vue?vue&type=script&lang=js"
import style0 from "./RedirectItems.vue?vue&type=style&index=0&id=3bdf9f0c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports